import { render, staticRenderFns } from "./IrrigationPlanDetail.vue?vue&type=template&id=6ca57d14&scoped=true"
import script from "./IrrigationPlanDetail.vue?vue&type=script&lang=js"
export * from "./IrrigationPlanDetail.vue?vue&type=script&lang=js"
import style0 from "./IrrigationPlanDetail.vue?vue&type=style&index=0&id=6ca57d14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca57d14",
  null
  
)

export default component.exports